var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActionNeeded(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-249 -423) translate(249 423)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 112,
    fill: "#FF8C7A",
    fillOpacity: 0.2,
    rx: 15
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FF2727",
    transform: "translate(53 27.965)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.429,
    cy: 52.035,
    rx: 3.429,
    ry: 3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M1.779 0.035L6.35 0.091 5.714 39.591 1.143 39.534z",
    transform: "rotate(-.807 3.746 19.813)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionNeeded);
export default __webpack_public_path__ + "static/media/action-needed.923e05eb.svg";
export { ForwardRef as ReactComponent };